<template>
  <div class="form-certification">
    <edit-table
      :option="option"
      :data="formatData"
      :loading="loading"
      @submit-add="handleSubmit"
      @submit-edit="handleUpdate"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
    >
      <template slot="headLeftAera">
        <a-date-picker
          format="YYYY"
          mode="year"
          :value="year"
          :open="yearOpen"
          :allow-clear="false"
          @openChange="openChangeByYear"
          @panelChange="panelChangeByYear"
        />
      </template>
      <!-- 自定义列 -->
      <!-- <template
        slot="table-row"
        slot-scope="{row}"
      >
        {{ row }}
      </template> -->
    </edit-table>
    <!-- <a-month-picker
      v-model="month"
      placeholder="Select month"
      format="YYYY-MM"
      :allow-clear="false"
    /> -->
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vacationAPI from '@/api/staff/vacation/index'
import { deepClone } from '@/util/util'

export default {
  components: {
    EditTable,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    staffId: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isMyInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      redata: [],
      loading: false,
      yearOpen: false,
      // 需要number转string的类型
      hasToStringTypes: ['select'],
      currentYear: moment(new Date()).format('YYYY'),
      year: moment(new Date()).format('YYYY'),
    }
  },
  computed: {
    option() {
      const option = {
        menu: false,
        addBtn: false,
        columns: [
          {
            label: this.i18n('labelVacation.vacationName'),
            field: 'vacationName',
            formOption: {
              rules: 'required',
            },
          },
          {
            label: this.i18n('labelVacation.year'),
            field: 'year',
            type: 'number',
          },
          {
            label: this.i18n('labelVacation.thisYearDays'),
            field: 'thisYearDays',
            // offInLieuEdit: true,
            // edit: true,
            // edit: this.currentYear === this.year && !this.isMyInfo,
            type: 'number',
            formOption: {
              numberMin: 0,
              numberMax: 100,
            },
          },
          {
            label: this.i18n('labelVacation.lastYearDays'),
            field: 'lastYearDays',
            offInLieuEdit: false,
            edit: false,
            // edit: this.currentYear === this.year && !this.isMyInfo,
            type: 'number',
            formOption: {
              numberMin: 0,
              numberMax: 100,
            },
          },
          {
            label: this.i18n('labelVacation.creditDays'),
            field: 'creditDays',
            // offInLieuEdit: true,

            // edit: this.currentYear === this.year && !this.isMyInfo,
            type: 'number',
            formOption: {
              numberMin: 0,
              numberMax: 100,
            },
          },
          {
            label: this.i18n('labelVacation.haveDays'),
            field: 'haveDays',
            type: 'number',
            formOption: {
              numberMin: 0,
              numberMax: 100,
            },
          },
          {
            label: this.i18n('labelVacation.usedDays'),
            field: 'usedDays',
            // offInLieuEdit: true,
            // edit: this.currentYear === this.year && !this.isMyInfo,
            type: 'number',
            formOption: {
              numberMin: 0,
              numberMax: 100,
            },
          },
          {
            label: this.i18n('labelVacation.pending'),
            field: 'pendingDays',
            // offInLieuEdit: true,
            // edit: this.currentYear === this.year && !this.isMyInfo,
            type: 'number',
            formOption: {
              numberMin: 0,
              numberMax: 100,
            },
          },
          {
            label: this.i18n('labelVacation.balance'),
            field: 'balance',
            // edit: true,
            edit: false,
            type: 'number',
          },
          {
            label: this.i18n('labelVacation.vacationType'),
            field: 'vacationType',
            tdClass: 'vgt-center-align',
            thClass: 'vgt-center-align',
            sortable: false,
            dictField: 'vacationTypeName',
            type: 'select',
            dictBizCode: 'staff_vacation_type',
            rules: 'required',
          },
        ],
      }
      return option
    },
    formatData() {
      const res = []

      this.redata.forEach((row) => {
        const temp = row
        this.option.columns.forEach((item) => {
          const type = item.formOption ? item.formOption.type : 'none'
          if (this.hasToStringTypes.indexOf(type) !== -1) {
            temp[item.field] = row[item.field].toString()
          }
          const balance =
            Number(temp.haveDays) -
            Number(temp.usedDays) -
            Number(temp.pendingDays)
          temp.balance = parseFloat(balance).toFixed(1)
        })
        res.push(temp)
      })

      console.log(res, 'res+==')
      return res
    },
  },
  mounted() {
    // this.redata = this.data
    this.onLoad()
  },
  methods: {
    async onLoad() {
      this.loading = true
      const res = await vacationAPI.detail({
        staffId: this.staffId,
        year: this.year,
      })
      const temp = res.data.data
      this.redata = temp.map((el) => {
        const obj = deepClone(el)
        if (obj.year === this.currentYear) {
          obj.option_editBtn = false
        }
        return obj
      })

      this.loading = false
    },
    openChangeByYear(status) {
      if (status) {
        this.yearOpen = true
      } else {
        this.yearOpen = false
      }
    },
    panelChangeByYear(value) {
      this.year = moment(value).format('YYYY')
      this.onLoad()
      this.yearOpen = false
    },
    // 国际化
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    handleSubmit(done, row = {}) {
      const params = row
      params.staffId = this.staffId
      vacationAPI
        .add(params)
        .then(async () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          await this.onLoad()
          done()
        })
        .catch((err) => {
          done()
        })
    },
    handleUpdate(done, row = {}) {
      const params = {
        vacationInfoId: row.id,
        thisYearDays: row.thisYearDays,
        lastYearDays: row.lastYearDays,
        usedDays: row.usedDays,
        creditDays: row.creditDays,
        staffIds: this.staffId,
        year: this.year,
      }

      vacationAPI
        .update(params)
        .then(async () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          await this.onLoad()
          done()
        })
        .catch((err) => {
          done()
        })
    },
    handleRowDel(done, row) {
      vacationAPI
        .remove(row.id)
        .then(async () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          await this.onLoad()
          done()
        })
        .catch((err) => {
          done()
        })
    },
    refreshChange() {
      this.onLoad()
    },
  },
}
</script>
<style lang="scss">
.form-certification {
  &-top {
    text-align: right;
  }
  .table-td {
    text-align: center;
    line-height: 50px;
    &-sm {
      width: 200px;
    }
  }
}
</style>
